export class PhotobookPage {
    // static EventListeners = {
    //     'ShoptetDOMPageContentLoaded': NotFoundPage.doLoadOnShoptetDOMPageContentLoaded,
    // }
    // static doLoadOnShoptetDOMPageContentLoaded() {}
    // static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    // static doLoadOnShoptetDOMContentLoaded() {}
    // static doLoadOnChange() {}
    static async doInit() {
        PhotobookPage.doStyleMisc();
        return true;
    }
    static doStyleMisc() {
        $('body').addClass('in-photobook');

        $('.in-photobook .content-inner > h1').text('Photobooks');
    }
}
